'use strict';

module.exports = Object.freeze({
  'Content Permission': Object.freeze([
    'Brand Marketing',
    'Product Marketing',
    'New Product Marketing',
    'Specific Product Marketing',
    'Discount Offers',
    'Partner Offers',
    'Customer Research',
    'Newsletter',
    'Membership',
    'Volunteering',
    'Fundraising',
  ]),
  'Data Sharing Permission': Object.freeze([
    'Sharing Data within Group',
    'Sharing Data with Partners',
  ]),
  'Data Purpose Permission': Object.freeze([
    'Automated Decision Making',
    'Location Tracking',
    'Online Tracking',
  ]),
  'Data Management Permission': Object.freeze([
    'Cross-Border Transfers',
  ]),
});
